
export interface DateObject {
    year: number;
    month: number;
    day: number;
  }
  
  export interface optionGetTodayDate {
    currentDate?: string;
    nbDay?: number;
    nbMonth?: number;
    nbYear?: number;
    resetHour?: boolean;
    resetMinute?: boolean;
    resetDay?: boolean;
    nbHour?: number;
    resetMonth?: boolean;
  
  }
  export const getTodayDate = (option?: optionGetTodayDate) => {
    const date =  option?.currentDate? new Date(option.currentDate) : new Date();
  
    if (option?.resetHour) {
      date.setHours(0, 0, 0, 0);
    }
  
    if (option?.resetMinute) {
      date.setMinutes(0, 0, 0);
    }
  
    if (option?.resetDay) {
      date.setDate(1);
    }
  
    if(option?.resetMonth) {
      date.setMonth(1);
      date.setDate(1);
      date.setHours(0, 0, 0, 0);
      date.setMinutes(0, 0, 0);
    }
    
    if (option?.nbHour) {
      date.setHours(date.getHours() + option.nbHour);
    }
    
  
  
    if (option?.nbDay) {
      date.setDate(date.getDate() + option.nbDay);
    }
  
    if (option?.nbMonth) {
      date.setMonth(date.getMonth() + option.nbMonth);
    }
  
    if (option?.nbYear) {
      date.setFullYear(date.getFullYear() + option.nbYear);
  
    }
  
  
  
  
    return date.toISOString();
  }